import React, { createContext, useState, useContext } from 'react';
import en from './i18n/en.json';
import de from './i18n/de.json';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('en');
    const translations = language === 'en' ? en : de;
    return (
        <LanguageContext.Provider value={{ translations, setLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);